import * as Yup from 'yup';

export const resetEmail = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email address')
    .required('Email is required.'),
});

export const resetOtp = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email address')
    .required('Email is required.'),
  otp: Yup.string().required('Otp is required.'),
});

export const resetPassword = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email address')
    .required('Email is required.'),
  otp: Yup.string().required('Otp is required.'),
  password: Yup.string().required('Password is required.'),
  confirmPassword: Yup.string()
    .required('Confirm password is required.')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});
